import { render, staticRenderFns } from "./CookieBannerComp.vue?vue&type=template&id=8fe7cf88&scoped=true&"
import script from "./CookieBannerComp.vue?vue&type=script&lang=js&"
export * from "./CookieBannerComp.vue?vue&type=script&lang=js&"
import style0 from "./CookieBannerComp.vue?vue&type=style&index=0&id=8fe7cf88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe7cf88",
  null
  
)

export default component.exports